module.exports = __webpack_public_path__ + "images/Suso-top-home-2.png";